import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '@blueprintjs/core'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import { ScrollAppear } from 'client/components/ScrollAppear/ScrollAppear'
import Integrations from 'images/svg/apps.svg'
import { ClientLocaleNS } from 'lib/constants/locales'

type TProps = {}

const IntegrationsBlock: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.WebsiteBuilderPage)

  return (
    <ResponsiveBlock size="wide" type="white">
      <div className="flex w-full flex-col-reverse items-center gap-8 py-8 lg:flex-row lg:py-20">
        <div className="relative right-0 items-center">
          <ScrollAppear className="flex w-full items-center">
            <img src={Integrations} className="flex w-full object-contain" />
          </ScrollAppear>
        </div>
        <div className="relative flex w-full flex-col items-center gap-8 lg:left-0 lg:w-1/2 lg:items-start lg:gap-10">
          <Text
            tagName="h2"
            className="font-primary-medium---22pt w-full text-center lg:font-primary-medium---32pt lg:text-left"
          >
            {t('integrations_block.title')}
          </Text>
          <Text tagName="p" className="font-primary-regular---15pt text-center text-text-secondary-alt lg:text-left">
            {t('integrations_block.caption')}
          </Text>
        </div>
      </div>
    </ResponsiveBlock>
  )
}

export { IntegrationsBlock }
